export var KeycloakMessagePatterns;
(function (KeycloakMessagePatterns) {
    KeycloakMessagePatterns["BACKEND_UPDATE_USER"] = "BACKEND_UPDATE_USER";
    KeycloakMessagePatterns["BACKEND_DELETE_USER"] = "BACKEND_DELETE_USER";
    KeycloakMessagePatterns["BACKEND_INVITED_USER"] = "BACKEND_INVITED_USER";
    KeycloakMessagePatterns["BACKEND_RESEND_INVITE_MAIL"] = "BACKEND_RESEND_INVITE_MAIL";
    KeycloakMessagePatterns["BACKEND_SEND_INVITATION_MAIL_WITH_LINK"] = "BACKEND_SEND_INVITATION_MAIL_WITH_LINK";
    KeycloakMessagePatterns["BACKEND_CALL_INVITE_WITH_LINK_TO_REGISTRATION"] = "BACKEND_CALL_INVITE_WITH_LINK_TO_REGISTRATION";
    KeycloakMessagePatterns["BACKEND_USER_SEND_PASSWORD_RESET_MAIL"] = "BACKEND_USER_SEND_PASSWORD_RESET_MAIL";
    KeycloakMessagePatterns["BACKEND_USER_CHANGE_EMAIL"] = "BACKEND_USER_CHANGE_EMAIL";
    KeycloakMessagePatterns["BACKEND_RESET_SECOND_FACTOR"] = "BACKEND_RESET_SECOND_FACTOR";
})(KeycloakMessagePatterns || (KeycloakMessagePatterns = {}));
//# sourceMappingURL=keycloak-message-patterns.enum.js.map